import { useRef, useState } from "react";
import { C } from "../../shared/theme";
import { formatDeadlineDate } from "../../shared/deadlines";

// The goal's due date on its colour band, which changes the date when tapped (Craig, 24 Oct 2026: "change the due
// date more easily by tapping on it rather than having to Edit the goal"). The phone's own date picker opens: an
// invisible date field lies over the pill, so a tap lands on it. A goal with no date shows "Add a due date".
// onChange(date) gets the ISO date, or null when the picker is cleared.
// A desktop date field reports each digit of a year as it's typed (0002, 0020, 0202, 2027); only a whole one is saved.
const isWholeDate = (v) => /^\d{4}-\d{2}-\d{2}$/.test(v) && Number(v.slice(0, 4)) >= 1900;

export function DueDatePill({ deadline, onChange }) {
  const inputRef = useRef(null);
  const [focused, setFocused] = useState(false); // the field is invisible, so the pill shows its focus
  // Desktop browsers open the picker only from their small calendar icon; this opens it from anywhere on the pill.
  const openPicker = () => { try { inputRef.current?.showPicker?.(); } catch { /* the tap itself opens it */ } };
  return (
    <span style={{ position: "relative", display: "inline-flex", minHeight: 44, alignItems: "center" }}>
      <span aria-hidden="true" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, fontWeight: 600, color: C.onGoal, background: "rgba(0,0,0,0.28)", border: `1px solid ${C.onGoalDim}`, borderRadius: 20, padding: "4px 12px",
        outline: focused ? `2px solid ${C.onGoal}` : "none", outlineOffset: 2 }}>
        {/* A calendar, so the pill reads as something to tap. */}
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
        </svg>
        {deadline ? `Due ${formatDeadlineDate(deadline)}` : "Add a due date"}
      </span>
      <input ref={inputRef} type="date" value={deadline || ""} onClick={openPicker} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
        aria-label={deadline ? `Due ${formatDeadlineDate(deadline)}. Change the due date` : "Add a due date"}
        onChange={e => { const v = e.target.value; if (!v) onChange(null); else if (isWholeDate(v)) onChange(v); }}
        style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0, border: "none", padding: 0, margin: 0, fontSize: 16, cursor: "pointer" }} />
    </span>
  );
}
